import './form.less';
import PropTypes from 'prop-types';
import React from 'react';
import { Field, reduxForm } from 'redux-form';

import InputField from '../../shared/form-elements/input';
import TextField from '../../shared/form-elements/textarea';
import CheckboxField from '../../shared/form-elements/checkbox';
import RadioField from '../../shared/form-elements/radio';
import UploadField from '../../shared/form-elements/upload';
import SelectField from '../../shared/form-elements/select/field';

const Form = ({
	handleSubmit,
	pristine,
	submitting,
	loadOptions,
	spinnerToggle
}) => (
	<div className="form-container">
		<div className="form-container__body">
			<form className="ui-form showcase__form">
				<div className="ui-form__element">
					<Field name="file" component={UploadField} placeholder="Upload"  preparationFile={preparationFileMock}/>
				</div>
				<div className="ui-form__element">
					<Field name="email" placeholder="Email" component={InputField} />
				</div>
				<div className="ui-form__element">
					<Field name="describe" placeholder="User story" component={TextField} />
				</div>
				<div className="ui-form__element">
					<Field name="is-manager" labelText="Is manager" component={CheckboxField} />
				</div>
				<div className="ui-form__element">
					<Field name="user-rank" labelText="Novice" defaultValue="novice" component={RadioField} />
					<Field name="user-rank" labelText="Master" defaultValue="master" component={RadioField} />
				</div>

				<div className="ui-form__element">
					<Field
						name="asyncSelect"
						placeholder="Improve Async Example"
						component={SelectField}
						multi={true}
						options={loadOptions} />
				</div>

				<div className="ui-form__element">
					<Field
						name="staticSelect"
						placeholder="Improve Static Example"
						component={SelectField}
						searchable={false}
						multi={true}
						options={[
							{ value: 'one', label: 'One' },
							{ value: 'two', label: 'Two' }
						]} />
				</div>

				<div className="ui-form__element">
					<Field
						name="staticSelectSingle"
						placeholder="Static single example"
						component={SelectField}
						searchable={false}
						multi={false}
						options={[
							{ value: 'one', label: 'One' },
							{ value: 'two', label: 'Two' }
						]} />
				</div>

				<div className="ui-form__element">
					<Field
						name="staticSelectMultiSingle"
						placeholder="Static single searchable example"
						component={SelectField}
						multi={false}
						options={loadOptions} />
				</div>

				<div className="ui-form__element">
					<button
						className="ui-btn"
						onClick={ e => {
							e.preventDefault();
							spinnerToggle();
							setTimeout(() => spinnerToggle(), 1000);
						}}>Show spinner</button>
				</div>

				<div className="login__form-element">
					<button className="ui-btn ui-btn-primary">Сохранить</button>
				</div>
			</form>
		</div>
	</div>
);

Form.propTypes = {
	handleSubmit: PropTypes.func,
	pristine: PropTypes.bool,
	submitting: PropTypes.bool,
	loadOptions: PropTypes.func,
	spinnerToggle: PropTypes.func
};

const preparationFileMock = (file, nextAction) => {
	const reader = new FileReader();
	reader.readAsDataURL(file);
	reader.onloadend = function () {
		nextAction(reader.result);
	};
};

export default reduxForm({
	form: 'showcaseForm'
})(Form);


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/showcase/components/form.js